export default __webpack_public_path__ + "static/media/Pioneer_10_at_Jupiter-min.8820fe32.jpg";